module.exports = __webpack_public_path__ + "img/a3.e6c9547d.jpg";